import type { ReactNode } from "react";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

interface SettingsSectionProps {
  title: string;
  children: ReactNode;
}

export function SettingsSectionBase({ title, children }: SettingsSectionProps) {
  const { theme } = useUnistyles();

  return (
    <View
      bg="surfaceCardInner"
      borderWidth={1}
      borderColor="borderCard"
      borderRadius={theme.spacing.xl}
      p="5xl"
      gap="3xl"
    >
      <Text textStyle="sm/semibold" color="textMuted">
        {title}
      </Text>
      <View gap="md">{children}</View>
    </View>
  );
}
